// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f2f4f6;
  }
  
  .registration-form {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 500px;
    padding: 40px;
    max-width: 90%;
  }
  
  .registration-form h2 {
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group input,
  .form-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .form-group select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: url('https://cdn1.iconfinder.com/data/icons/feather-2/24/chevron-down-16.png')
      no-repeat right center;
    background-size: 20px 20px;
    padding-right: 30px;
    cursor: pointer;
  }
  
  .form-group button {
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
  }
  
  .form-group button:hover {
    background: #0056b3;
  }
  
  /* Media Query para hacerlo responsive */
  @media (max-width: 480px) {

    .registration-form {
      width: 90%;
      padding: 20px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Register/RegisterUser.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB;4BACwB;IACxB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,wCAAwC;EACxC;;IAEE;MACE,UAAU;MACV,aAAa;IACf;EACF","sourcesContent":[".registration-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #f2f4f6;\n  }\n  \n  .registration-form {\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n    width: 500px;\n    padding: 40px;\n    max-width: 90%;\n  }\n  \n  .registration-form h2 {\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: center;\n  }\n  \n  .form-group {\n    margin-bottom: 20px;\n  }\n  \n  .form-group input,\n  .form-group select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  .form-group select {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background: url('https://cdn1.iconfinder.com/data/icons/feather-2/24/chevron-down-16.png')\n      no-repeat right center;\n    background-size: 20px 20px;\n    padding-right: 30px;\n    cursor: pointer;\n  }\n  \n  .form-group button {\n    background: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    padding: 10px 20px;\n    cursor: pointer;\n  }\n  \n  .form-group button:hover {\n    background: #0056b3;\n  }\n  \n  /* Media Query para hacerlo responsive */\n  @media (max-width: 480px) {\n\n    .registration-form {\n      width: 90%;\n      padding: 20px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
